import { IAttendanceReq } from '@tsin-core/services/http/attendance.service';

const ACTION_SCOPE = '[Attendance]';

export class GetAttendancesByAdministration {
  static readonly type = `${ACTION_SCOPE} Get Attendances By Administration`;
  constructor(public payload: string) { }
}

export class GetAttendancesByApplication {
  static readonly type = `${ACTION_SCOPE} Get Attendances By Application`;
  constructor(public payload: string) { }
}

export class MarkAttendance {
  static readonly type = `${ACTION_SCOPE} Mark Attendance`
  constructor(public payload: IAttendanceReq) { }
}
